import React from 'react';
import numeral from 'numeral';
import { TablePagination, IconButton, makeStyles } from '@material-ui/core';
import { TablePaginationProps } from '@material-ui/core/TablePagination/TablePagination';
import { MDSTypography } from '@marqvision/mds-v2';
import { IcoArrowLeftOutline, IcoArrowRightOutline } from '../assets';
import Theme from './Theme';

const useStyles = makeStyles(() => ({
  root: {
    padding: '0 6px',
    borderBottom: '0',
    background: 'white',
  },
  toolbar: {
    minHeight: '32px',
    padding: '0',
  },
  actions: {
    marginLeft: '0',
  },
  caption: {
    '& span': {
      marginRight: '4px',
    },
  },
  buttons: {
    flexShrink: 0,
    '& button': {
      marginRight: '0 !important',
      '& svg': {
        color: Theme.palette.bluegray['800'],
      },
    },
    '& button.Mui-disabled': {
      '& svg': {
        opacity: 0.5,
      },
    },
  },
}));

interface IOwnProps {
  label?: string;
}

type IProps = IOwnProps & TablePaginationProps;

const TablePaginationActions = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { count, page, rowsPerPage, onPageChange } = props;

  const handleBackButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page - 1);
  };

  const handleNextButtonClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    onPageChange(event, page + 1);
  };

  return (
    <div className={classes.buttons}>
      <IconButton onClick={handleBackButtonClick} disabled={page === 0}>
        <IcoArrowLeftOutline />
      </IconButton>
      <IconButton onClick={handleNextButtonClick} disabled={page >= Math.ceil(count / rowsPerPage) - 1}>
        <IcoArrowRightOutline />
      </IconButton>
    </div>
  );
};

/**
 * @deprecated
 * MDSPagination from `@marqvision/mds-v2`
 * [링크](http://mds.marq.ai.s3-website.us-east-2.amazonaws.com/?path=/docs/2-components-molecules-pagination--docs)
 * */
export const Pagination = (props: IProps): JSX.Element => {
  const classes = useStyles();
  const { label, ...restProps } = props;
  const fontSize = restProps.size === 'small' ? 's' : 'm';

  const formattedNumber = (value: number) => {
    return numeral(value).format('0,0');
  };

  return (
    <TablePagination
      {...restProps}
      classes={{
        root: classes.root,
        toolbar: classes.toolbar,
        actions: classes.actions,
        caption: classes.caption,
      }}
      rowsPerPageOptions={[]}
      labelDisplayedRows={({ from, to, count }) => (
        <MDSTypography
          variant="body"
          weight="regular"
          size={fontSize}
          color="color/content/neutral/default/normal"
          as="div"
        >
          <MDSTypography
            variant="body"
            weight="medium"
            size={fontSize}
            color="color/content/neutral/default/normal"
            as="span"
          >
            {label ? `${label} ` : ''}
            {formattedNumber(from)}-{formattedNumber(to)}
          </MDSTypography>
          of {formattedNumber(count)}
        </MDSTypography>
      )}
      ActionsComponent={TablePaginationActions}
    />
  );
};

export default Pagination;
